import { AnimatePresence, motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { pageMotion } from "../../components/motion/pageMotion";
import { Container, SideContainer } from './styles'
import Profile from '../../components/profile'
import Projects from "../../components/projects";
import Users from "../../components/users"
import Settings from "../../components/settings";
import Dashboard from "../../components/dashboard";
import KanbanBoard from "../../components/kanban_board";
import Guardian from "../../components/guardian";
import ContasWilder from "../../components/projects_t_engineering/ContasWilder/ContasWilder";
import InternRegisterUser from '../../components/inter_register_user';
import UserIntern from "../../pages/user_intern";
import Sidebar from "../../components/sidebar";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { appStatus } from "../../store/modules/app_status/actions";
import { userService } from "../../services/userService";
import { canAccessDashboard, isPropOrGuardianUser } from "../../utils/userRoles";
import { goToPanel } from "../../utils/appNavigation";
import { publicNavigation } from "../../config/publicNavigation";
import MyAlertsHome from "../../components/field_alerts/MyAlertsHome";

/** Subfluxos do shell que não podem ser sobrescritos pelo `panel` da rota. */
const SHELL_SUBFLOWS = new Set(["edit_user", "cad_new_user"]);

/**
 * Shell autenticado.
 * `panel` (quando vem de uma rota real: /dashboard, /users, /guardian…)
 * define o painel exibido e sincroniza o Redux. Sem `panel` (rota /welcome
 * legada), usa o app_status atual — preservando sub-fluxos como cad_new_user.
 */
const Welcome = ({ panel }) => {
  const location = useLocation();
  const user = location?.state?.user;
  const app_status = useSelector((state) => state.app_status.status);
  const currentUser = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = React.useState(false);

  useEffect(() => {
    let cancelled = false;

    const ensureSession = async () => {
      try {
        await userService.getMe();
      } catch {
        if (!cancelled) navigate(publicNavigation.login || '/login');
      }
    };

    ensureSession();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  // Alinha Redux com a rota — mas NÃO sobrescreve subfluxos (edit_user, etc.)
  useEffect(() => {
    if (!panel) return;
    if (SHELL_SUBFLOWS.has(app_status)) return;
    if (panel !== app_status) {
      dispatch(appStatus(panel));
    }
  }, [panel, app_status, dispatch]);

  // Subfluxo tem prioridade sobre o panel da URL
  const effectiveStatus = SHELL_SUBFLOWS.has(app_status)
    ? app_status
    : (panel || app_status);

  // PROP / GUARDIAN não acessam Dashboard — manda para Meus Alertas
  useEffect(() => {
    if (
      (effectiveStatus === "Dashboard" || !effectiveStatus) &&
      currentUser &&
      !canAccessDashboard(currentUser)
    ) {
      goToPanel(dispatch, navigate, "Meus Alertas", { replace: true });
    }
  }, [effectiveStatus, currentUser, dispatch, navigate]);

  const fallbackPanel =
    currentUser && isPropOrGuardianUser(currentUser) ? (
      <MyAlertsHome />
    ) : (
      <Dashboard />
    );

  return (
    <Container>
      <Sidebar collapsed={collapsed.toString()} setCollapsed={setCollapsed} />
      <SideContainer collapsed={collapsed.toString()}>
        <AnimatePresence mode="wait">
          <motion.div
            key={effectiveStatus || "home"}
            initial={pageMotion.initial}
            animate={pageMotion.animate}
            exit={pageMotion.exit}
            transition={pageMotion.transition}
            style={{ width: "100%", minHeight: "100%" }}
          >
        {effectiveStatus === 'Projetos' ? <Projects /> :
         effectiveStatus === 'Usuários' ? <Users /> :
         effectiveStatus === 'Meu Perfil' ? <Profile /> :
         effectiveStatus === "Desenvolvimento" ? <KanbanBoard /> :
         effectiveStatus === "Configurações" ? <Settings /> :
         effectiveStatus === "cad_new_user" ? <InternRegisterUser userType={location.state?.userType}/> :
         effectiveStatus === "edit_user" ? <UserIntern user={user} /> :
         effectiveStatus === "Meus Alertas" ? <MyAlertsHome /> :
         effectiveStatus === "Dashboard" ? (
           canAccessDashboard(currentUser) ? <Dashboard /> : <MyAlertsHome />
         ) :
         effectiveStatus === "Guardião" ? <Guardian/> :
         effectiveStatus === "Contas" ? <ContasWilder/>:
          fallbackPanel}
          </motion.div>
        </AnimatePresence>
      </SideContainer>
    </Container>
  )
};

export default Welcome;
